import EnquiriesGrid from "../../components/grids/EnquiriesGrid";
import AddEnquiryForm from "../../components/FormComps/Enquiries/AddEnquiryForm";
import EditEnquiryForm from "../../components/FormComps/Enquiries/EditEnquiryForm";
import AddClientForm from "../../components/FormComps/Clients/AddClientForm";
import SchedulesOfRatesPanel from "../../components/SchedulesOfRates/SchedulesOfRatesPanel";

import { useState, useEffect, useRef } from "react";
import { useToast } from "../../contexts/ToastContext";
import { useSessionState } from "../../helpers/useSessionState";

import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";

import {
  Drawer,
  DrawerContent,
  DrawerNavigation,
} from "@progress/kendo-react-layout";
import { Dialog } from "@progress/kendo-react-dialogs";
import { FaTimes } from "react-icons/fa";
import {
  submitEnquiry,
  updateEnquiry,
  getEnquiries,
  getEnquiriesForExport,
  deleteEnquiry,
} from "../../data/enquiryData";
import { submitQuote } from "../../data/quoteData";
import { submitJob } from "../../data/jobData";
import {
  getEnquiryTypes,
  getEnquiryExportTypes,
  getSiteTypes,
  clientsGrid,
  enquiryGrid,
} from "../../data/interfaces";

import { submitSite, getSites } from "../../data/siteData";
import { submitClient, getClients, getTargetClientByPhone } from "../../data/clientData";
import { getClientByIdV2, getAddressesForClientDropdown } from "../../data/accountsData";

import AddSiteForm from "../../components/FormComps/Sites/AddSiteForm";

import "../Styles.css";
import { deleteDocument } from "../../data/fileData";
import AccountForm from "../../components/FormComps/Accounts/AccountForm";

const Enquiries = (props: any) => {
  //Modal visibility states
  const [visibleClientModal, setVisibleClientModal] = useState<boolean>(false);
  const [visibleSiteModal, setVisibleSiteModal] = useState<boolean>(false);
  const [clientData, setClientData] = useState<clientsGrid[]>([]);
  const [siteData, setSiteData] = useState<getSiteTypes[]>([]);
  const [enquiryData, setEnquiryData] = useState<enquiryGrid[]>([]);
  const [enquiryExportData, setEnquiryExportData] = useState<getEnquiryExportTypes[]>([]);
  const [expanded, setExpanded] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [addFormVisible, setAddFormVisible] = useState(false);
  const [enquiryId, setEnquiryId] = useState(0);
  const [showDeleted, setShowDeleted] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Friendly enquiry reference for the edit drawer header (reported by
  // EditEnquiryForm once it loads the enquiry).
  const [editEnquiryRef, setEditEnquiryRef] = useState("");

  // Responsive enquiry-drawer width: roomier on large screens (room for the new
  // vertical nav rail), and caps at the viewport on smaller displays.
  const [viewportWidth, setViewportWidth] = useState(() => window.innerWidth);
  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Kendo caps an overlay drawer at 80% of the screen, so this is the width it really has.
  const normalDrawerWidth = Math.min(1200, Math.round(viewportWidth * 0.94), Math.floor(viewportWidth * 0.8));

  // The schedules of rates, open to the left of the Add enquiry drawer and
  // never over it. The drawer keeps its width where there's room for both, and
  // only narrows (to no less than 480px) where there isn't.
  const [ratesOpen, setRatesOpen] = useState(false);
  const ratesWidthBasis = viewportWidth - Math.round(Math.min(620, Math.max(480, viewportWidth * 0.36))) - 48;
  const ratesGap = 16;
  const ratesDrawerWidth = Math.max(
    Math.min(480, normalDrawerWidth),
    Math.min(normalDrawerWidth, viewportWidth - Math.max(320, Math.round(ratesWidthBasis * 0.36125)) - ratesGap)
  );
  const ratesPanelWidth = Math.max(0, Math.min(Math.round(ratesWidthBasis * 0.36125), viewportWidth - ratesDrawerWidth - ratesGap));

  // Only beside the add form: closing the drawer, or the form, closes the rates too.
  const showRates = ratesOpen && expanded && addFormVisible;
  useEffect(() => {
    if (!(expanded && addFormVisible)) setRatesOpen(false);
  }, [expanded, addFormVisible]);

  const enquiryDrawerWidth = showRates ? ratesDrawerWidth : normalDrawerWidth;

  // Where the drawer's left edge really is, so the rates sit right against it
  // even while the drawer is still resizing.
  const drawerHostRef = useRef<HTMLDivElement>(null);
  const [drawerEdge, setDrawerEdge] = useState<number | null>(null);
  useEffect(() => {
    if (!showRates) return;
    const drawer = drawerHostRef.current?.querySelector<HTMLElement>(".k-drawer");
    if (!drawer) return;
    const measure = () => setDrawerEdge(Math.round(window.innerWidth - drawer.getBoundingClientRect().left));
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(drawer);
    window.addEventListener("resize", measure);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, [showRates]);
  const ratesRight = drawerEdge ?? enquiryDrawerWidth;

  /**
   * Account 
   */
  const [addAccountVisible, setAddAccountVisible] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const [accountMode, setAccountMode] = useState<"add"|"edit">("add");
  const [accountInitialTab, setAccountInitialTab] = useState<number>(0);
  const [phoneNumberForNewAccount, setPhoneNumberForNewAccount] = useState<string | undefined>(undefined);
  const [shouldOpenEnquiryAfterAccount, setShouldOpenEnquiryAfterAccount] = useState(false);

  /**
   * END account 
   */

  const { showToast } = useToast();
  const navigate = useNavigate();
  const { contactNumber } = useParams();

  const toggleModal = (type: string) => {
    switch (type.toLowerCase()) {
      case "client":
        setVisibleClientModal(!visibleClientModal);
        break;
      case "site":
        setVisibleSiteModal(!visibleSiteModal);
        break;
      default:
        console.log("Invalid modal type.");
        break;
    }
  };
  const [clientFromIncoming, setClientFromIncoming] = useState<string>("");
  const [initialFormValues, setInitialFormValues] = useState<any>(null);

  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const id = searchParams.getAll("id")[0];
    const client = searchParams.getAll("client")[0];

    if (id) {
      setExpanded(true);
      setEditFormVisible(true);
      setEnquiryId(Number(id))
    }
    if (client) {
      setClientFromIncoming(client);
    }
  }, []);

  // Handle contactNumber parameter from URL
  useEffect(() => {
    if (contactNumber) {
      const fetchClientByPhone = async () => {
        try {
          const clientData = await getTargetClientByPhone(contactNumber);
          
          if (clientData.partialMatch && clientData.matchingClient) {
            // Prepare initial form values
            const initialValues = {
              contactId: clientData.contactId || 0,
              clientName: {
                value: clientData.matchingClient.clientId,
                text: clientData.matchingClient.clientName,
              },
              siteAddr: {
                value: 0,
                text: '',
              },
              enquirysourceId: {
                value: 0,
                text: '',
              },
              dueDate: '',
              description: '',
              employeeAssignedToId: {
                value: 0,
                text: '',
              },
            };

            // If there's only one site for this client, pre-select it
            if (clientData.matchingSite && clientData.matchingSite.siteId) {
              initialValues.siteAddr = {
                value: clientData.matchingSite.siteId,
                text: clientData.matchingSite.siteAddr,
              };
            }

            setInitialFormValues(initialValues);
            setAddFormVisible(true);
            setEditFormVisible(false);
            setExpanded(true);
            showToast('Client found and pre-filled', 'success');
          } else {
            // No matching client found, open the add account screen
            setPhoneNumberForNewAccount(contactNumber);
            setShouldOpenEnquiryAfterAccount(true);
            setAddAccountVisible(true);
            setAccountMode("add");
            setSelectedAccountId(null);
            setAccountInitialTab(0);
            showToast('No matching client found. Please add a new account.', 'info');
          }
        } catch (error) {
          console.error('Error fetching client by phone:', error);
          showToast('Error loading client data', 'error');
        }
      };

      fetchClientByPhone();
    }
  }, [contactNumber]);

  const handleAddForm = () => {
    setAddFormVisible((prevState) => (!prevState ? true : true));
    setEditFormVisible(false);
    handleExpanded();
  };

  const handleEditForm = (id: number) => {
    setEnquiryId(id);
    setEditEnquiryRef("");
    setEditFormVisible((prevState) => (!prevState ? true : true));
    setAddFormVisible(false);
    handleExpanded();
  };

  const updateEnquiryHandler = (dataItem: any, id: number) => {
    console.log('updateEnquiryHandler - Received dataItem:', dataItem);
    console.log('updateEnquiryHandler - Received dueDate:', dataItem.dueDate);
    const enquiryObj = {
      enquiryId: id,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.contactId,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value,
      description: dataItem.description,
      dueDate: dataItem.dueDate || null,
      employeeAssignedToId: dataItem.employeeAssignedToId.value,
      projectFolderUrl: dataItem.projectFolderUrl,
      deadDate: dataItem.deadDate || null,
      workingsAdjustmentPercent: dataItem.workingsAdjustmentPercent ?? null,
    };
    console.log('updateEnquiryHandler - enquiryObj:', enquiryObj);
    updateEnquiry(enquiryObj, id).then(() => {
      const fetchData = async () => {
        const enquiryData = await getEnquiries(showDead, showProgressed);
        setEnquiryData(enquiryData);
      };
      fetchData();
      setRefreshKey(prev => prev + 1);
    });
    showToast("Enquiry succesfully updated", "success");
  };

  const deleteEnquiryHandler = (id: number) => {
    deleteEnquiry(id).then(() => {
      const fetchData = async () => {
        const enquiryData = await getEnquiries(showDead, showProgressed);
        setEnquiryData(enquiryData);
      };
      fetchData();
    });
    handleExpanded();
    showToast("Enquiry succesfully removed", "success");
  };

  // Handle when a new account is created from the contact number flow
  const handleAccountCreated = async (clientId: number) => {
    if (shouldOpenEnquiryAfterAccount && clientId) {
      try {
        // Fetch the newly created client details
        const clientData = await getClientByIdV2(clientId);
        const addressesData = await getAddressesForClientDropdown(clientId);
        
        // Prepare initial form values
        const initialValues = {
          contactId: clientData.primaryContact?.contactId || 0,
          clientName: {
            value: clientData.clientId,
            text: clientData.clientName,
          },
          siteAddr: {
            value: 0,
            text: '',
          },
          enquirysourceId: {
            value: 0,
            text: '',
          },
          dueDate: '',
          description: '',
          employeeAssignedToId: {
            value: 0,
            text: '',
          },
        };

        // If there's only one address, pre-select it
        if (addressesData && addressesData.length === 1) {
          initialValues.siteAddr = {
            value: addressesData[0].value,
            text: addressesData[0].text,
          };
        }

        // Close the account dialog and open the enquiry form
        setAddAccountVisible(false);
        setInitialFormValues(initialValues);
        setAddFormVisible(true);
        setEditFormVisible(false);
        setExpanded(true);
        setShouldOpenEnquiryAfterAccount(false);
        setPhoneNumberForNewAccount(undefined);
        showToast('Account created. Ready to add enquiry.', 'success');
      } catch (error) {
        console.error('Error fetching client details:', error);
        showToast('Account created but failed to load details', 'error');
        setShouldOpenEnquiryAfterAccount(false);
      }
    }
  };

  const newEnquiryHandler = (dataItem: any) => {
    console.log('newEnquiryHandler - Received dataItem:', dataItem);
    console.log('newEnquiryHandler - Received dueDate:', dataItem.dueDate);
    const enquiryObj = {
      // clientName: dataItem.clientName,c
      contactId: dataItem.contactId,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value
        ? dataItem.enquirysourceId.value
        : 0,
      description: dataItem.description,
      dueDate: dataItem.dueDate || null,
      employeeAssignedToId: dataItem.employeeAssignedToId.value,
    };
    console.log('newEnquiryHandler - enquiryObj:', enquiryObj);
    submitEnquiry(enquiryObj).then(() => {
      handleRefreshData();
    });
    handleExpanded();
    showToast("Enquiry succesfully added", "success");
  };

  const newClientHandler = (dataItem: any) => {
    const clientObj = {
      clientName: dataItem.clientName,
      accountRef: dataItem.accountRef ? dataItem.accountRef : null,
      contactName: dataItem.contactFirstName + " " + dataItem.contactLastName,
      phone: dataItem.phone,
      email: dataItem.email ? dataItem.email : null,
      clientAddr: dataItem.clientAddr,
      postcode: dataItem.postcode,
      phone2: dataItem.phone2 ? dataItem.phone2 : null,
      fax: dataItem.fax ? dataItem.fax : null,
      tradeContact: dataItem.tradeContact ? dataItem.tradeContact : null,
      email2: dataItem.email2 ? dataItem.email2 : null,
      email3: dataItem.email3 ? dataItem.email3 : null,
      websiteUrl: dataItem.websiteUrl ? dataItem.websiteUrl : null,
      vatNum: dataItem.vatNum ? dataItem.vatNum : null,
      directdebitEmail: dataItem.directdebitEmail
        ? dataItem.directdebitEmail
        : null,
    };
    submitClient(clientObj).then(() => {
      const fetchData = async () => {
        const clientData = await getClients(showDeleted);
        setClientData(clientData);
      };
      fetchData();
    });
    toggleModal("client");
    showToast("Client succesfully added", "success");
  };

  const newSiteHandler = (dataItem: any) => {
    const siteObj = {
      siteAddr: dataItem.siteAddr,
      postcode: dataItem.postcode,
    };
    submitSite(siteObj).then(() => {
      const fetchData = async () => {
        const siteData = await getSites(false);
        setSiteData(siteData);
      };
      fetchData();
    });
    toggleModal("site");
    showToast("Site succesfully added", "success");
  };

  const convertEnquiryQuoteHandler = (dataItem: any, enquiryId: number) => {
    const quoteObj = {
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.contactId,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value,
      description: dataItem.description,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost,
      followupDate: dataItem.followupDate
        ? dataItem.followupDate.toISOString()
        : null,
      enquiryId: enquiryId,
      employeeAssignedToId: dataItem.employeeAssignedToId.value,
    };
  
    submitQuote(quoteObj).then(() => {
      navigate("/quotes");
    });
    handleExpanded();
    showToast("Enquiry has been moved to Quotes", "success");
  };

  const convertEnquiryJobHandler = (dataItem: any, enquiryId: number) => {
    const jobObj = {
      jobId: null,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value,
      departmentId: dataItem.departmentId.value,
      description: dataItem.description,
      purchaseOrder: dataItem.purchaseOrder,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost ? dataItem.cost : 0,
      proformaCost: dataItem.proformaCost ? dataItem.proformaCost : 0,
      firstHourInvoiced: dataItem.firstHourInvoiced,
      startDate: dataItem.startDate.toISOString(),
      endDate: dataItem.endDate.toISOString(),
      enquiryId: enquiryId,
      employeeProjectManagerId: dataItem.employeeProjectmanager.value,
      quoteId:
        dataItem.quoteId && dataItem.quoteId.value
          ? dataItem.quoteId.value
          : null,
      jobEmployeeIds: [],
      contactId: dataItem.contact.contactId,
      // Stored as a comma separated string, the same shape the quote
      // conversion sends and the jobs grid filters on.
      notifiableWorks: Array.isArray(dataItem.notifiableWorks)
        ? dataItem.notifiableWorks.join(',')
        : dataItem.notifiableWorks || '',
    };
   
    submitJob(jobObj).then(() => {
      navigate("/jobs");
    });
    handleExpanded();
    showToast("Enquiry has been moved to Jobs", "success");

  };

  const removeDocuemntHandler = (id: number) => {
    deleteDocument(id).then(() => {
      const fetchData = async () => {
        const enq = await getEnquiries(showDead, showProgressed);
        setEnquiryData(enq)
      }
      fetchData()
    })
    showToast('Successfully removed document', 'success')
  }

  // Same session keys as EnquiriesGrid so the page and the grid restore in step
  const [showDead, setShowDead] = useSessionState("enquiries.showDead", false);
  const [showProgressed, setShowProgressed] = useSessionState("enquiries.showProgressed", false);
  useEffect(() => {
    const fetchData = async () => {
      const enquiryData = await getEnquiries(showDead, showProgressed);
      const enquiryExportData = await getEnquiriesForExport(showDead, showProgressed);
      
      setEnquiryData(enquiryData);
      setEnquiryExportData(enquiryExportData);
    };

    fetchData();
  }, [showDead, showProgressed]);

  const handleExpanded = () => {
    setExpanded((prevState) => !prevState);

    if (editFormVisible) {
      setEditFormVisible(false);
    }
    if (addFormVisible) {
      setAddFormVisible(false);
    }
  };

  const handleClosePanel = () => {
    setExpanded(false);
    setEditFormVisible(false);
    setAddFormVisible(false);
  };

  const handleRefreshData = async () => {
    const enquiryData = await getEnquiries(showDead, showProgressed);
    const enquiryExportData = await getEnquiriesForExport(showDead, showProgressed);
    
    setEnquiryData(enquiryData);
    setEnquiryExportData(enquiryExportData);
    setRefreshKey(prev => prev + 1);
  };

  const handleSelect = () => {
    setExpanded(false);
  };

  const handleDead = (value: boolean) => {
    setShowDead(value);
  };

  const handleProgressed = (value: boolean) => {
    setShowProgressed(value);
  };

  return (
    <div>
      {showRates && (
        <SchedulesOfRatesPanel
          right={ratesRight}
          width={Math.min(ratesPanelWidth, Math.max(0, viewportWidth - ratesRight - ratesGap))}
          maxWidth={Math.max(0, viewportWidth - ratesRight - ratesGap)}
          onClose={() => setRatesOpen(false)}
        />
      )}
      <div ref={drawerHostRef}>
      <Drawer
        expanded={expanded}
        position={"end"}
        width={enquiryDrawerWidth}
        mode="overlay"
        animation={{
          duration: 400,
        }}
        onOverlayClick={handleExpanded}
        onSelect={handleSelect}
      >
        <DrawerContent>
          <DrawerNavigation>
            {addFormVisible && (
              <>
                <div className="jobdrawer__header">
                  <h1 className="jobdrawer__title">Add Enquiry</h1>
                  <button
                    type="button"
                    className="jobdrawer__close"
                    onClick={handleExpanded}
                    aria-label="Close"
                  >
                    <FaTimes />
                  </button>
                </div>
                <div className="form__wrapper">
                  <AddEnquiryForm
                    lockEdit={props.lockEdit}
                    onEnquirySubmit={newEnquiryHandler}
                    onAddClientToggle={() => toggleModal("client")}
                    onAddSiteToggle={() => toggleModal("site")}
                    setAddAccountVisible={setAddAccountVisible}
                    setAccountMode={setAccountMode}
                    setSelectedAccountId={setSelectedAccountId}
                    setAccountInitialTab={setAccountInitialTab}
                    initialValues={initialFormValues}
                    onShowRates={() => setRatesOpen(true)}
                  />
                </div>
              </>
            )}

            {editFormVisible && (
              <>
                <div className="jobdrawer__header">
                  <h1 className="jobdrawer__title">
                    Edit Enquiry
                    {editEnquiryRef && (
                      <span className="jobdrawer__ref">{editEnquiryRef}</span>
                    )}
                  </h1>
                  <button
                    type="button"
                    className="jobdrawer__close"
                    onClick={handleExpanded}
                    aria-label="Close"
                  >
                    <FaTimes />
                  </button>
                </div>
                <EditEnquiryForm
                  onEnquiryRefLoaded={setEditEnquiryRef}
                  setAddAccountVisible={setAddAccountVisible}
                  setAccountMode={setAccountMode}
                  setSelectedAccountId={setSelectedAccountId}
                  setAccountInitialTab={setAccountInitialTab}
                  lockEdit={props.lockEdit}
                  onEditSubmit={updateEnquiryHandler}
                  onEnquiryId={enquiryId}
                  onConvertQuoteSubmit={convertEnquiryQuoteHandler}
                  onConvertJobSubmit={convertEnquiryJobHandler}
                  onDeleteSubmit={deleteEnquiryHandler}
                  onAddSiteToggle={toggleModal}
                  onDocumentDelete={removeDocuemntHandler}
                  onClose={handleClosePanel}
                  onRefresh={handleRefreshData}
                />
              </>
            )}

          </DrawerNavigation>

          <EnquiriesGrid
            clientFromIncoming={clientFromIncoming}
            lockEdit={props.lockEdit}
            onAddToggle={handleAddForm}
            onEditToggle={handleEditForm}
            onData={enquiryData}
            onExportData={enquiryExportData}
            onShowDead={handleDead}
            onShowProgressed={handleProgressed}
            refreshKey={refreshKey}
          />

          {visibleClientModal && (
            <Dialog
              width={500}
              height={700}
              title={"Please confirm"}
              onClose={() => toggleModal("client")}
            >
              <AddClientForm onClientSubmit={newClientHandler} />
            </Dialog>
          )}

          {visibleSiteModal && (
            <Dialog
              width={500}
              height={700}
              title={"Please confirm"}
              onClose={() => toggleModal("site")}
            >
              <AddSiteForm onSiteSubmit={newSiteHandler} />
            </Dialog>
          )}

          {addAccountVisible && (
            <Dialog
              width={"70vw"}
              height={"90vh"}
              title={"Add new account"}
              onClose={() => setAddAccountVisible(false)}
            >
              <AccountForm 
                onClose={() => {
                  setAddAccountVisible(false);
                  setShouldOpenEnquiryAfterAccount(false);
                  setPhoneNumberForNewAccount(undefined);
                }}
                mode={accountMode} 
                id={selectedAccountId || null} 
                setAccountId={(id) => {
                  setSelectedAccountId(id);
                  handleAccountCreated(id);
                }}
                initialTab={accountInitialTab}
                phoneNumber={phoneNumberForNewAccount}/>

            </Dialog>
          )}
        </DrawerContent>
      </Drawer>
      </div>
    </div>
  );
};

export default Enquiries;
